import { render, staticRenderFns } from "./PreviewDocumentPersonal.vue?vue&type=template&id=5b5b959a&scoped=true&"
import script from "./PreviewDocumentPersonal.vue?vue&type=script&lang=js&"
export * from "./PreviewDocumentPersonal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDocumentPersonal.vue?vue&type=style&index=0&id=5b5b959a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b959a",
  null
  
)

export default component.exports